var _style, _polyline, _polyline2, _polyline3, _rect, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#ABB4BC;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "11,31 11,10 21,10 21,31 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "21,31 21,16 30,16 30,31 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "2,31 2,21 11,21 11,31 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    className: "st0",
    width: 8,
    height: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    className: "st0",
    width: 4,
    height: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 14,
    x2: 18,
    y2: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 25,
    x2: 7,
    y2: 25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 29,
    x2: 7,
    y2: 29
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 18,
    x2: 18,
    y2: 18
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 22,
    x2: 18,
    y2: 22
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 26,
    x2: 18,
    y2: 26
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14,
    y1: 30,
    x2: 18,
    y2: 30
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24,
    y1: 20,
    x2: 24,
    y2: 21
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27,
    y1: 20,
    x2: 27,
    y2: 21
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 25
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27,
    y1: 24,
    x2: 27,
    y2: 25
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24,
    y1: 28,
    x2: 24,
    y2: 29
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27,
    y1: 28,
    x2: 27,
    y2: 29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.8f6eea07.svg";
export { ForwardRef as ReactComponent };